import decorate from './ui'
import reducer, { updateUI } from './reducer'

export default decorate
export { reducer }
export { decorate }
export { updateUI }
